// standard react component
import React from 'react';
import '../App.css';
import '../index.css';
import play from '../resources/play-solid.svg'
import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../config';
import {
    Bars3Icon,
    PauseIcon,
  } from '@heroicons/react/24/outline'

  
function TrafficLogTableEntry(props) {
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0); // Track audio progress (0-100)
    // Remove the unused duration state variable
    const audioRef = useRef(null);
    const isEditable = props.isEditable !== false;
    const navigate = useNavigate();

    const viewSpotByCartNumber = async (cartNumber) => {
        if (!cartNumber) return;
        try {
            const response = await fetch(apiUrl(`/media/cart?cart=${cartNumber}`), {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                mode: 'cors',
            });
            if (!response.ok) {
                console.error(`Failed to fetch spot for cart ${cartNumber}: ${response.status}`);
                alert(`Could not find spot for cart number ${cartNumber}`);
                return;
            }
            const spots = await response.json();
            console.log(`Fetched spots for cart ${cartNumber}:`, spots);

            // check length of array should be 1 and then extract [0]._id or [0].id
            if (!Array.isArray(spots) || spots.length === 0) {
                console.error(`No spots found for cart ${cartNumber}`);
                alert(`No spot found for cart number ${cartNumber}`);
                return;
            }
            if (spots.length > 1) {
                console.warn(`Multiple spots found for cart ${cartNumber}, using the first one.`);
            }

            const spot = spots[0];
            const spotId = spot._id || spot.id;
            if (!spotId) {
                alert(`No spot found for cart number ${cartNumber}`);
                return;
            }
            navigate(`/spotview/${spotId}`);
        } catch (error) {
            console.error(`Error fetching spot for cart ${cartNumber}:`, error);
            alert(`Error looking up cart number ${cartNumber}`);
        }
    };

    const viewCustomerByCartNumber = async (cartNumber) => {
        if (!cartNumber) return;
        try {
            const response = await fetch(apiUrl(`/media/cart?cart=${cartNumber}`), {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                mode: 'cors',
            });
            if (!response.ok) {
                console.error(`Failed to fetch spot for cart ${cartNumber}: ${response.status}`);
                alert(`Could not find spot for cart number ${cartNumber}`);
                return;
            }
            const spots = await response.json();
            console.log(`Fetched spots for cart ${cartNumber}:`, spots);

            // check length of array should be 1 and then extract [0].customer_id
            if (!Array.isArray(spots) || spots.length === 0) {
                console.error(`No spots found for cart ${cartNumber}`);
                alert(`No spot found for cart number ${cartNumber}`);
                return;
            }
            if (spots.length > 1) {
                console.warn(`Multiple spots found for cart ${cartNumber}, using the first one.`);
            }

            const spot = spots[0];
            const customerId = spot.customer_id;
            if (!customerId) {
                alert(`No customer found for cart number ${cartNumber}`);
                return;
            }
            navigate(`/customerview/${customerId}`);
        } catch (error) {
            console.error(`Error fetching spot for cart ${cartNumber}:`, error);
            alert(`Error looking up cart number ${cartNumber}`);
        }
    };

    const elipsis = (addElipsis) => {
        if (addElipsis) {
            return "...";
        } else {
            return "";
        }
    }

    const truncateText = (text, maxLength, addElipsis) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + elipsis(addElipsis);
        } else {
            return text;
        }
    }

    const handlePlayPause = () => {
        console.log('Play/Pause button clicked for cart number:', props.logentry);
        console.dir(props.logentry);
        if (!audioRef.current) {
            // Create audio element if it doesn't exist
            // const cartNumber = props.logentry.cart_number.toString().padStart(8, '0');
            const audioUrl = props.logentry.href;
            
            audioRef.current = new Audio(audioUrl);
            
            // Remove the loadedmetadata event listener since we don't use duration
            audioRef.current.addEventListener('timeupdate', () => {
                if (audioRef.current.duration) {
                    const progressPercent = (audioRef.current.currentTime / audioRef.current.duration) * 100;
                    setProgress(progressPercent);
                }
            });
            
            audioRef.current.addEventListener('ended', () => {
                setIsPlaying(false);
                setProgress(0); // Reset progress when audio ends
            });
            
            audioRef.current.addEventListener('error', (e) => {
                console.error('Audio error:', e);
                setIsPlaying(false);
                setProgress(0);
                alert('Could not load audio file');
            });
        }

        if (isPlaying) {
            // Pause audio
            audioRef.current.pause();
            setIsPlaying(false);
        } else {
            // Play audio
            audioRef.current.play()
                .then(() => {
                    setIsPlaying(true);
                })
                .catch((error) => {
                    console.error('Error playing audio:', error);
                    alert('Could not play audio file');
                });
        }
    };

    const backgroundColor = props.isDragging ? 'bg-green-400' : 'bg-emerald-500';
    // Create dynamic style for the progress circle

    const progressCircleStyle = {
        background: `conic-gradient(white 0deg, white ${progress * 3.6}deg, transparent ${progress * 3.6}deg, transparent 360deg)`,
        borderRadius: '100%',
        mask: 'radial-gradient(circle at center, transparent 40%, white 42%, white 58%, transparent 60%)',
        WebkitMask: 'radial-gradient(circle at center, transparent 40%, white 42%, white 58%, transparent 60%)',
    };

    const PlayPauseButton = ({ className }) => (
        <button 
            className={`relative p-1 ${!isPlaying ? 'hover:bg-emerald-600' : ''} rounded-full transition-colors duration-150 flex-shrink-0 ${className}`}
            onClick={handlePlayPause}
        >
            {/* Animated circle when playing */}
            {isPlaying && (
                <div 
                    className="absolute inset-0 border-2 border-white border-t-transparent rounded-full"
                    style={progressCircleStyle}
                />
            )}
            
            {/* Play/Pause icon */}
            {isPlaying ? (
                <PauseIcon className="w-6 h-6 font-bold text-black relative z-10" />
            ) : (
                <img src={play} className="w-6 h-6 relative z-10" alt="play spot" />
            )}
        </button>
    );

    return (
        <div className={`mx-3 ${backgroundColor} rounded-md`}>
            <div className="grid grid-cols-5 sm:grid-cols-6 sm:gap-x-2 lg:gap-x-2 py-1">
                {/* Time Column - hidden on small screens */}
                <div className="hidden sm:flex px-3 items-center">
                    <div className="text-black">{props.logentry.time_of_day}</div>
                </div>

                {/* Drag Handle Column */}
                <div className="px-1 flex items-center">
                    <div 
                        {...(props.dragHandleProps || {})}
                        className={`${isEditable ? 'cursor-move hover:bg-emerald-600' : 'cursor-not-allowed opacity-60'} p-2 rounded-md transition-colors duration-150`}
                        title={isEditable ? 'Drag to reorder' : 'Editing disabled for current/past logs'}
                    >
                        <Bars3Icon className="h-5 w-5 text-black" />
                    </div>
                </div>
                
                {/* Cart Number Column */}
                <div className="px-2 flex items-center">
                    <button 
                        className="p-1 hover:bg-emerald-600 rounded transition-colors duration-150 w-full text-left"
                        onClick={() => viewSpotByCartNumber(props.logentry.cart_number)}
                    >
                        <div className="text-black">
                            <div className="md:hidden">{truncateText(props.logentry.cart_number, 7, false)}</div>
                            <div className="hidden sm:hidden md:block">{props.logentry.cart_number}</div>
                        </div>
                    </button>
                </div>
                
            {/* Client Column - spans 2 columns */}
            <div className="px-2 flex items-center col-span-2 sm:col-span-2">
                <button 
                    className="p-1 hover:bg-emerald-600 rounded transition-colors duration-150 w-full text-left"
                    onClick={() => viewCustomerByCartNumber(props.logentry.cart_number)}
                >
                    <div className="text-black truncate">{truncateText(props.logentry.client, 40, true)}</div>
                </button>
            </div>
            
            {/* Length & Play Button Column - shared column on larger screens */}
            <div className="hidden sm:flex items-center justify-between px-1">
                {/* Length - left half */}
                <div className="flex items-center justify-center w-1/2">
                    <div className="text-black text-sm">{props.logentry.length}</div>
                </div>
                
                {/* Play Button - right half */}
                <div className="flex items-center justify-center w-1/2">
                    <PlayPauseButton />
                </div>
            </div>
            
            {/* Play Button Column - mobile only */}
            <div className="sm:hidden px-1 flex items-center justify-center">
                <PlayPauseButton />
            </div>
        </div>
    </div>
    );
}

export default TrafficLogTableEntry;